const operationArchivesEn = {
  status: {
    completed: "Completed",
    aborted: "Aborted",
    inProgress: "In Progress",
  },
  filters: {
    textSearchPlaceholder: "Search target, pattern...",
    operationPackagePlaceholder: "Operation Package",
    allPackages: "All Packages",
    anchorDatePlaceholder: "Anchor Date",
    targetPlaceholder: "Target",
    allTargets: "All Targets",
    clearFilters: "Clear Filters",
  },
};

export default operationArchivesEn;
